import styled from 'styled-components';

export const WidgetContainerStyled = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  `;


export const WidgetContentStyled = styled.div`
    flex: 1;
    background-color: white;
    border: 1px solid !important;
    border-color: rgb(225, 220, 220) !important;
    /* padding-top: 2em; */
    border-radius: 5px !important;
    overflow: hidden;
    box-shadow:
      4px 6px 10px rgba(220, 220, 220, 0.4),
    -4px 6px 10px rgba(220, 220, 220, 0.4),
      0 6px 10px rgba(220, 220, 220, 0.4);
    margin-bottom: 5px !important;
`;

export const WidgetLabelStyled = styled.h3`
  margin: 12px 0 10px 3px;
  color: var(--secondaryColor) !important;
`;
 